import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {TipHeadLinks} from '../../components/modules/pannelli/HeadLink';
import '../../components/modules/pannelli/themesScreen.scss';

function IntroTipologia() {
    const {theme} = useSingleTheme('tipologia');
    const tipologia_Theme = theme;
    const {articles} = useArticles('tipologia');
    const article = articles.slice(0, 1) || [];
    const articles_Intro = article[0]; 
    const {paragraphs} = useParagraphs('tipologia_1');

    return (
        <section>
            {theme && <TipHeadLinks title={tipologia_Theme.tema_titolo} /> }
            <ThemesScreen theme={tipologia_Theme} article={articles_Intro} paragraphs={paragraphs}/> 
        </section>
    )
}
export default IntroTipologia;
